export default __webpack_public_path__ + "static/media/seatBelt.d0d964db.png";